import { render, staticRenderFns } from "./ShowStudentProfilePhotos.vue?vue&type=template&id=7ef0da7f&scoped=true&"
import script from "./ShowStudentProfilePhotos.vue?vue&type=script&lang=js&"
export * from "./ShowStudentProfilePhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef0da7f",
  null
  
)

export default component.exports